import React, {useState, useEffect, useRef} from 'react';
import {Form, Modal} from 'antd';
import emiter, {_EVENTS} from '../../../../../events'
import FreeRenewal from './free-renewal'
import {useOrderList} from "../../../../../hooks/order-management/order-list";
type CommonGlobalPropsVO = {
    enums?: any
}

const FreeRenewalModal: React.FC<CommonGlobalPropsVO> = props => {
    const { enums, } = props
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [title, setTitle] = useState('免费续租');
    const dataRef = useRef({});
    const configRef: any = useRef({});
    const [data, setData] = useState<any>({});
    const { freeRenewSubmit } = useOrderList()


    const openModal = (params: any) => {
        dataRef.current = params || {};
        setData(params)
        form.resetFields();
        setOpen(true);
        setDisabled(!!params.disabled);
        setTitle('免费续租');
    };


    const onClose = () => {
        form.resetFields();
        dataRef.current = {}
        setOpen(false);
        setDisabled(false);
        setTitle('');
    };

    const onOk = () => {
        form
            .validateFields()
            .then(async (values) => {
                const data = form.getFieldsValue();
                // 提交请求，操作成功，并刷新列表
                freeRenewSubmit(data, dataRef.current)
                onClose()
            })
            .catch(() => {});
    };


    useEffect(() => {
        emiter.on(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.FEE_RENEW, openModal);
        return () => {
            emiter.removeAllListeners(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.FEE_RENEW)
        }
    }, []);

    return (
        <>
            {
                open && <Modal zIndex={1001} title={title} width={'800px'} centered open={open} onOk={onOk} onCancel={onClose}>
                    <Form form={form} labelCol={{ span: 4 }} disabled={disabled}>
                        <FreeRenewal enums={enums} data={data}></FreeRenewal>
                    </Form>
                </Modal>
            }
        </>

    );
};

export default FreeRenewalModal;
